import { ROUTINE_TYPES } from '../../types/Fisiofit/routine';

export const MAX_DURATION = 365;

export const ROUTINE_TYPE_OPTIONS = [
  { label: 'Rutina de usuario', value: ROUTINE_TYPES.USER },
  { label: 'Plantilla', value: ROUTINE_TYPES.TEMPLATE },
];
